export const routes = {
  MAIN: '/',
  AUTH_ERROR: '/auth/error',
  MEETING_GROUP: '/meeting-group',
  SERVERS: '/workspace',
  SESSIONS: '/conversation',
  DISCORD_VOICES: '/discord-voices',
  PROFILE: '/profile',
  TARIFFS: '/tariffs',
  COMPANY_MANAGEMENT: '/company-management',
  ACTIVE_CONVERSATIONS: '/active-conversations',
  SUPPORT: '/support',
  TEMPLATES: '/templates',
  TEMPLATE_PROTOCOL: '/template-protocol',
};
